import React, { useState } from "react";
import { Button } from "@telia/teddy";
import { useLocation } from "react-router-dom";
import PAGES from "../../../../../../constants/pages";
import { ConnectedShoppingCart } from "../../../../navigation";
import CancelOrderModal from "./CancelOrderModal";
import "./ShoppingCart.less";

const RetailerShoppingCart: React.FC = () => {
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const location = useLocation();
    const isSummaryPage = location.pathname === PAGES.RETAILER.ORDER.SUMMARY.URL;

    return (
        <div className="retailerShoppingCart">
            <div className="retailerShoppingCart__sticky">
                <ConnectedShoppingCart useStandalone isRetailer />
                {!isSummaryPage && (
                    <Button variant="tertiary-purple" size="sm" onClick={() => setIsCancelModalOpen(true)}>
                        Avbryt ordre
                    </Button>
                )}
            </div>
            {isCancelModalOpen && <CancelOrderModal onClose={() => setIsCancelModalOpen(false)} />}
        </div>
    );
};

export default RetailerShoppingCart;
